// extracted by mini-css-extract-plugin
module.exports = {"button":"PriceList_button__1eAEp","icon":"PriceList_icon__3HErG","chatButtonCell":"PriceList_chatButtonCell__1IOy2","collapseIcon":"PriceList_collapseIcon__37r5x"};